module.exports = __webpack_public_path__ + "img/selection-or-1.d7a59e0e.png";